module.exports = __webpack_public_path__ + "media/images/DPCL-b35ce3b3001a1983fa17adcccae70b37.png";